module.exports = __webpack_public_path__ + "img/prod_tecnica_ciudad_artes.c281f66f.jpg";